import { clientId, lpRequest } from '../../../../core/api/lp-request';

/** Fees go as numbers, a blank one as 0 (cb's default). The backend answers 409 on a duplicate name. */
export const createPaymentSetting = async (
  name: string,
  fee_per_trip: string,
  fee_per_order: string,
  base_fee: string,
  additional_fee: string
): Promise<any> => {
  const result = await lpRequest(`/fleet/${clientId()}/payment-type`, {
    method: 'POST',
    body: {
      name,
      fee_per_trip: Number(fee_per_trip || 0),
      fee_per_order: Number(fee_per_order || 0),
      base_fee: Number(base_fee || 0),
      additional_fee: Number(additional_fee || 0)
    }
  });

  return { id: result.message, name };
};
